import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pc_slider_0.jpg'
import _imports_1 from '@/assets/pc_slider_1.png'
import _imports_2 from '@/assets/pc_slider_2.png'
import _imports_3 from '@/assets/pc_slider_3.png'
import _imports_4 from '@/assets/pc_slider_4.png'
import _imports_5 from '@/assets/homemerch.png'


const _withScopeId = n => (_pushScopeId("data-v-147e64f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "carouselpc",
  class: "carousel slide"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"carousel-indicators\" data-v-147e64f4><button type=\"button\" data-bs-target=\"#carouselpc\" data-bs-slide-to=\"0\" class=\"active\" aria-current=\"true\" aria-label=\"Slide 1\" data-v-147e64f4><span data-v-147e64f4></span></button><button type=\"button\" data-bs-target=\"#carouselpc\" data-bs-slide-to=\"1\" aria-label=\"Slide 2\" data-v-147e64f4><span data-v-147e64f4></span></button><button type=\"button\" data-bs-target=\"#carouselpc\" data-bs-slide-to=\"2\" aria-label=\"Slide 3\" data-v-147e64f4><span data-v-147e64f4></span></button><button type=\"button\" data-bs-target=\"#carouselpc\" data-bs-slide-to=\"3\" aria-label=\"Slide 4\" data-v-147e64f4><span data-v-147e64f4></span></button><button type=\"button\" data-bs-target=\"#carouselpc\" data-bs-slide-to=\"4\" aria-label=\"Slide 5\" data-v-147e64f4><span data-v-147e64f4></span></button></div>", 1)
const _hoisted_3 = { class: "carousel-inner" }
const _hoisted_4 = { class: "carousel-item active" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "d-block carousel-item-img",
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "carousel-item-img-shadow" }, null, -1))
const _hoisted_7 = { class: "carousel-caption" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "carousel-caption-title" }, "El Gióoch", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carousel-caption-description" }, [
  /*#__PURE__*/_createTextVNode("Hai mai pensato di comprarti tutto Corso Campi? O di costruire un hotel in Corso Mazzini?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Divertiti con la tradizione cremonese, i luoghi della città e i suoi modi di dire…tutto racchiuso in un"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("gioco in scatola per tutta la famiglia!")
], -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Acquista ora!")
const _hoisted_11 = { class: "carousel-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "d-block carousel-item-img",
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "carousel-item-img-shadow" }, null, -1))
const _hoisted_14 = { class: "carousel-caption" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "carousel-caption-title" }, "G’hèt vist che robe??", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carousel-caption-description" }, [
  /*#__PURE__*/_createTextVNode("La linea Dialetto fortifica il tuo spirito cremonese e ti insegna a parlare come tuo nonno."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("La puoi regalare anche ai tuoi amici australiani grazie alla comoda traduzione inglese, check it out!")
], -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Vai alla collezione")
const _hoisted_18 = { class: "carousel-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "d-block carousel-item-img",
  alt: ""
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "carousel-item-img-shadow" }, null, -1))
const _hoisted_21 = { class: "carousel-caption" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "carousel-caption-title" }, "Muri cremonesi", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carousel-caption-description" }, [
  /*#__PURE__*/_createTextVNode("Cremona è territorio di musica, di cibo, di agricoltura, di storia e di convivialità."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("5 caratteristiche che abbiamo messo su carta e che tu puoi mettere sul muro; scopri tutta la collezione!")
], -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Vai alla collezione")
const _hoisted_25 = { class: "carousel-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "d-block carousel-item-img",
  alt: ""
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "carousel-item-img-shadow" }, null, -1))
const _hoisted_28 = { class: "carousel-caption" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "carousel-caption-title" }, "Cremona addosso", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carousel-caption-description" }, [
  /*#__PURE__*/_createTextVNode("Nel nostro e-shop trovate 3 linee di prodotti che rendono divertente e gggiovane anche una tradizione"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("secolare. Belle idee e prodotti di qualità, tutti accomunati da tanta cura, ricerca, e ovviamente"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("cremonesità!")
], -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Vai alla collezione")
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"carousel-item\" data-v-147e64f4><img src=\"" + _imports_4 + "\" class=\"d-block carousel-item-img\" alt=\"\" data-v-147e64f4><div class=\"carousel-item-img-shadow\" data-v-147e64f4></div><div class=\"carousel-caption\" data-v-147e64f4><span class=\"carousel-caption-title\" data-v-147e64f4>I tour di Cremona</span><p class=\"carousel-caption-description\" data-v-147e64f4>Dalla tradizione liutaria alle eccellenze gastronomiche, passando per la natura e il Po, Cremona ha<br data-v-147e64f4>molto da offrire. Scopri le visite guidate e le esperienze che ti faranno toccare con mano la storia<br data-v-147e64f4>millenaria della città!</p><a href=\"https://experience.procremona.it/it/\" target=\"_blank\" class=\"btn btn-pc btn-pc-secondary carousel-caption-link\" data-v-147e64f4>Vai alle esperienze</a></div></div>", 1)
const _hoisted_33 = { class: "home-top-experience" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "home-top-experience-title" }, "Top experience", -1))
const _hoisted_35 = { class: "home-top-experience-container-image" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "home-top-experience-actions d-block d-md-none" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "home-top-experience-container" }
const _hoisted_43 = { class: "home-top-experience-container-info" }
const _hoisted_44 = { class: "home-top-experience-info" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { class: "home-top-experience-info-footer" }
const _hoisted_48 = ["href"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "home-top-experience-container-next d-none d-md-flex" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "home-merch" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "homemerch"
}, null, -1))
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Guarda la collezione")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createVNode(_component_router_link, {
              to: "/merch-detail/637b8af612ae4",
              class: "btn btn-pc btn-pc-secondary carousel-caption-link"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _hoisted_16,
            _createVNode(_component_router_link, {
              to: "/merch",
              class: "btn btn-pc btn-pc-secondary carousel-caption-link"
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _hoisted_23,
            _createVNode(_component_router_link, {
              to: "/merch",
              class: "btn btn-pc btn-pc-secondary carousel-caption-link"
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _hoisted_30,
            _createVNode(_component_router_link, {
              to: "/merch",
              class: "btn btn-pc btn-pc-secondary carousel-caption-link"
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_32
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("img", {
          src: $setup.experiences[$setup.experiencesIndex].image,
          alt: ""
        }, null, 8, _hoisted_36),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("button", {
            class: "btn btn-icon home-top-experience-chevron back",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.before && $setup.before(...args))),
            onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.before && $setup.before(...args)))
          }, _hoisted_39, 32),
          _createElementVNode("button", {
            class: "btn btn-icon home-top-experience-chevron next",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args))),
            onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
          }, _hoisted_41, 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("span", {
              class: "home-top-experience-info-title",
              innerHTML: $setup.experiences[$setup.experiencesIndex].title
            }, null, 8, _hoisted_45),
            _createElementVNode("p", {
              class: "home-top-experience-info-description",
              innerHTML: $setup.experiences[$setup.experiencesIndex].description
            }, null, 8, _hoisted_46),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("a", {
                href: $setup.experiences[$setup.experiencesIndex].link,
                target: "_blank",
                class: "btn btn-pc btn-pc-secondary home-top-experience-info-button"
              }, "Vedi esperienza", 8, _hoisted_48),
              _createElementVNode("button", {
                class: "btn btn-icon home-top-experience-chevron back d-none d-md-block",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.before && $setup.before(...args))),
                onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.before && $setup.before(...args)))
              }, _hoisted_50, 32)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("button", {
            class: "btn btn-icon home-top-experience-chevron next",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args))),
            onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
          }, _hoisted_53, 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _hoisted_55,
      _createVNode(_component_router_link, {
        to: "/merch",
        class: "btn btn-pc btn-pc-secondary home-merch-button"
      }, {
        default: _withCtx(() => [
          _hoisted_56
        ]),
        _: 1
      })
    ])
  ], 64))
}